@import '../../assets/fontawesome-6.7.2-web/css/all.min.css';

.button {
	display: flex;
	height: 50px;
	padding: 0;
	background: #3e7671;
	border: none;
	outline: none;
	border-radius: 5px;
	overflow: hidden;
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
    min-width: 220px;
    max-width: 220px;
}

.button:hover {
	background: #008168;
}

.button:active {
	background: #3e7671;
}

.button-text{
	display: block;
	margin: auto;
	padding: 0 10px;
	color: #fff;
  text-overflow: ellipsis;
  overflow:hidden;
  white-space:nowrap;
  width: 50%;
  text-transform: capitalize;
}

.button-icon {
    margin: auto;
    padding: 10px;
    font-size: 20px;
    color: #ffffff;
}

.button-profile {
	margin: auto;
}

.button-profile svg {
  display: flex;
  margin-left: 4px;
  background-color: #fff;
  border-radius: 4px;
}

.profile-image {
  display: flex;
  margin-left: 4px;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background-color: #fff;
}

.button-text-full-width {
    width: auto!important;
}

.button-link {
    text-decoration: none!important;
}

/* Drop down section */
.dropdown {
    position: relative;
    display: inline-block;
}
  
.dropdown-content {
    display: none;
    position: absolute;
    right: 0;
    background-color: #f9f9f9;
    min-width: 180px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
    border-radius: 5px;
    text-align: left!important;
}
  
.dropdown-content-link a {
    color: #71797E;
    padding: 16px 20px;
    text-decoration: none;
    display: block;
    cursor: pointer;
    font-size: 1rem!important;
}
  
.dropdown-content-link a:hover {
    background-color: #f1f1f1;
    color: #000;
    opacity: 0.7;
}

.dropdown:hover .dropdown-content {
    display: block;
}


/* Modal Content */
.modal {
    display: none;
    position: fixed;
    z-index: 1;
    padding-top: 100px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
    text-align: center;
  }
  

  .modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 40%;
  }

  .modal-body {
    max-height: 50vh;
    overflow-y: auto;
  }
  
  .close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }
  
  .close:hover,
  .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }

  .modal-app {
    background-color: #c3e9bc;
    padding: 15px;
    margin: 10px;
    border-radius: 5px;
  }

  .external-app-link {
    text-decoration:none; 
    color: #000;
  }

  .gray-text {
    color: #606060;
  }

  .green-text {
    color: #3e7671;
  }

  #countdown {
    position: relative;
    margin: auto;
    margin-top: 30px;
    height: 40px;
    width: 40px;
    text-align: center;
  }
  
  #countdown-number {
    color: #2e2e2e;
    display: inline-block;
    line-height: 40px;
  }
  
  #countdown svg {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    transform: rotateY(-180deg) rotateZ(-90deg);
  }
  
  #countdown svg circle {
    stroke-dasharray: 113px;
    stroke-dashoffset: 0px;
    stroke-linecap: round;
    stroke-width: 4px;
    stroke: #008168;
    fill: none;
    animation: countdown 6s linear infinite forwards;
  }
  
  @keyframes countdown {
    from {
      stroke-dashoffset: 0px;
    }
    to {
      stroke-dashoffset: 113px;
    }
  }

  .lds-ring {
    color: #fff
  }
  .lds-ring {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    position: relative;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 25px;
    height: 25px;
    margin: 3px;
    border: 2px solid currentColor;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: currentColor transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

.dropdown-content .dropdown-user-profile {
  padding: 12px 10px 8px 18px;
  border-bottom: 1px solid #aaaaaa;
}

.dropdown-content .dropdown-user-profile .username {
  font-size: 16px;
  color: #2e2e2e;
  text-transform: capitalize;
}

.dropdown-content .dropdown-user-profile .first-last-name {
  font-size: 13px;
  color: #606060;
}


.menu-bar-icons {
  color: #008168;
  display: inline-block;
  margin-right: 8px;
  font-size: 18px;
}

.other-links-list {
  /* display: flex;
  justify-content: space-between; */
  padding: 14px;
  background-color: #f1f1f1;
  margin-bottom: 8px;
  text-align: start;
  border-radius: 5px;
}

/* .box {
  box-shadow: 0 3px 12px rgba(0,0,0,0.15);
  background-color: #fff;
  border-radius: 3px;
  overflow: hidden;
} */

.tab-list {
  margin: 0px 40px;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  width: 85%;
  border-bottom: 1px solid #aaa;
}

/* .tab-list::before {
  content: '';
  display: block;
  height: 2px;
  width: 50%;
  position: absolute;
  bottom: 0;
  background-color: #aaa;
  transition: .3s;
} */

.tab-item {
  flex: 1;
  text-align: center;
  transition: .3s;
  opacity: 0.5;
}

.tab-toggle {
  display: none;
}

.tab-content {
  display: none;
}

.tab-toggle:nth-child(1):checked ~ .tab-list .tab-item:nth-child(1),
.tab-toggle:nth-child(2):checked ~ .tab-list .tab-item:nth-child(2) {
  opacity: 1;
  color: #008168;
  border-bottom: 2px solid #008168;
}

.tab-toggle:nth-child(2):checked ~ .tab-list::before {
  transform: translateX(100%);
}

.tab-toggle:nth-child(3):checked ~ .tab-list::before {
  transform: translateX(200%);
}

.tab-toggle:nth-child(1):checked ~ .tab-container .tab-content:nth-child(1),
.tab-toggle:nth-child(2):checked ~ .tab-container .tab-content:nth-child(2) {
  display: block;
}

.tab-trigger {
  display: block;
  padding: 10px 0;
}

.tab-container {
  padding: 15px 30px;
}

.grid-view-menu {
  display: grid;
  gap: 4px;
  grid-template-columns: repeat(3, 1fr);
  align-content: start;
  padding: 8px;
  max-height: 230px;
  overflow-y: auto;
}

.grid-view-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 75px;
  height: 70px;
  padding: 6px;
  text-decoration: none;
  font-size: 13px;
  color: #128f8b;
  text-align: center;
  transition: transform 0.2s ease, background-color 0.1s ease;
  position: relative;
  z-index: 1;
  /* background-color: white; */
  border-radius: 3px;
  cursor: pointer;
}

.grid-view-link:hover {
  background-color: #eeeeee;
  transform: scale(1.1);
  z-index: 5;
}

.grid-view-link-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #71797e;
  width: 100%;
}

.grid-view-link:hover .grid-view-link-text {
  white-space: pre-wrap;
  overflow: visible;
  text-overflow: unset;
}

.grid-view-link i {
  transition: transform 0.2s ease;
}

.grid-view-link:hover i {
  transform: scale(1.1);
}

hr.solid {
  border-top: 1px solid #bbb;
  margin: 2px 0;
} 

/* ===== Overlay ===== */
.restricted-overlay {
  position: fixed;
  inset: 0;
  background: linear-gradient(135deg, #0f3d3e, #128f8b);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  z-index: 9999999;
  font-family: "Segoe UI", sans-serif;
}

/* ===== Card ===== */
.restricted-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 50px;
  max-width: 540px;
  width: 100%;
  text-align: center;
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.25);
  animation: fadeInUp 0.3s ease;
}

/* ===== Icon ===== */
.restricted-icon {
  font-size: 48px;
  color: #128f8b;
  margin-bottom: 30px;
}

/* ===== Text ===== */
.restricted-card h2 {
  margin-bottom: 10px;
  color: #128f8b;
}

.restricted-message {
  color: #555;
  font-size: 16px;
  margin-bottom: 30px;
  line-height: 1.5;
}

/* ===== Links Section ===== */
.restricted-links h4 {
  margin-bottom: 20px;
  color: #128f8b;
}

.link-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 20px;
  margin-bottom: 25px;
}

.restricted-link {
  background: #ecf2f2;
  padding: 10px;
  border-radius: 10px;
  text-decoration: none;
  color: #128f8b;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  transition: all 0.2s ease;
}

.restricted-link:hover {
  background: #128f8b;
  color: #fff;
}

/* ===== Buttons ===== */
.restricted-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.btn-primary {
  background: #128f8b;
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  transition: 0.2s;
}

.btn-primary:hover {
  background: #0f6e6b;
}

.btn-secondary {
  background: transparent;
  border: 2px solid #128f8b;
  color: #128f8b;
  padding: 8px 18px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;
}

.btn-danger {
  background: transparent;
  border: 2px solid #dc3545;
  color: #dc3545;
  padding: 8px 18px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;
}

.btn-secondary:hover {
  background: #128f8b;
  color: #fff;
}

/* ===== Animation ===== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
